(() => {
  if (window.bvPdpActivityLoaded) return;
  window.bvPdpActivityLoaded = true;

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const id = `bv-pdp-activity-${data.sectionId}`;
      const current = document.getElementById(id);
      const updated = data.html?.getElementById(id);
      if (!current || !updated) return;
      current.querySelector('.bv-pdp-activity__text').textContent = updated.querySelector('.bv-pdp-activity__text').textContent.trim();
    });
  }
})();
